import { InitialStateType } from "../types";

export const InitialState: InitialStateType = {
  chanelInfo: {
    name: "",
    description: "",
  },

  serverConfig: {
    server: "",
    port: "",
    tls: true,
    timeout: 60,
    user: "",
    password: "",
    error: "",
  },

  senderAndRecipients: {
    sender: "",
    recipients: [],
  },
};

const wizardStateReducer = (state: any, action: any) => {
  const form = action.payload.form;
  switch (action.type) {
    case "update":
      return {
        ...state,
        [form]: {
          ...state[form],
          ...action.payload.data,
        },
      };

    default:
      return state;
  }
};

export default wizardStateReducer;
